// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBzmtRExCgZakAueH9OTi51bnN3oSz7Kvc",
  authDomain: "superkonnectedwebsite.firebaseapp.com",
  projectId: "superkonnectedwebsite",
  storageBucket: "superkonnectedwebsite.firebasestorage.app",
  messagingSenderId: "1003348135208",
  appId: "1:1003348135208:web:17a5cdbe77b98783be541d",
  measurementId: "G-N6L6HBNCLK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase services
export const auth = getAuth(app);
// Force long-polling to avoid WebChannel transport issues on restricted networks
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// LinkedIn OAuth Provider for authentication
export const linkedinProvider = new OAuthProvider('linkedin.com');
linkedinProvider.addScope('openid');
linkedinProvider.addScope('profile');
linkedinProvider.addScope('email');

// Connect to emulators in development (disabled for now - requires Java)
// if (process.env.NODE_ENV === 'development' && process.env.USE_EMULATORS === 'true') {
//   // Connect to Firebase emulators
//   import('firebase/auth').then(({ connectAuthEmulator }) => {
//     try {
//       connectAuthEmulator(auth, 'http://localhost:9099');
//     } catch (error) {
//       // Emulator already connected
//     }
//   });
//
//   import('firebase/firestore').then(({ connectFirestoreEmulator }) => {
//     try {
//       connectFirestoreEmulator(db, 'localhost', 8080);
//     } catch (error) {
//       // Emulator already connected
//     }
//   });
//
//   import('firebase/storage').then(({ connectStorageEmulator }) => {
//     try {
//       connectStorageEmulator(storage, 'localhost', 9199);
//     } catch (error) {
//       // Emulator already connected
//     }
//   });
// }

// Configure Google Auth Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Add authorized domains for redirect
googleProvider.addScope('email');
googleProvider.addScope('profile');

export default app;
